import script from "./ChatWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatWidget.vue?vue&type=script&setup=true&lang=ts"

import "./ChatWidget.vue?vue&type=style&index=0&id=6716e1ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6716e1ec"]])

export default __exports__